import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

// Submit onboarding data
export const submitOnboardingData = async (payload) => {
  try {
    const response = await axiosInstance.post(API.hiringOnboardings.addOnboarding, payload);

    if (!(response.status >= 200 && response.status < 300)) {
      throw new Error("Failed to add onboarding data");
    }

    return response;
  } catch (error) {
    console.error("Error submitting onboarding data:", error);
    throw error;
  }
};

export const updateOnboardingData = async (payload) => {
  try {
    const response = await axiosInstance.put(API.hiringOnboardings.updateOnboarding, payload);

    if (!(response.status >= 200 && response.status < 300)) {
      throw new Error("Failed to add onboarding data");
    }

    return response;
  } catch (error) {
    console.error("Error submitting onboarding data:", error);
    throw error;
  }
};

export const fetchOnboardingEmployees = async (jobPostingId) => {
  try {
    const response = await axiosInstance.get(API.hiringJobApplicant.getListByPosting(jobPostingId));
    const applicants = Array.isArray(response.data?.applicants) ? response.data?.applicants : [];
    return applicants;
  } catch (error) {
    console.error("Error fetching employee details:", error);
    return null;
  }
};

export const getOnboardingByApplicant = async (jobapplicantId) => {
  try {
    const response = await axiosInstance.get(API.hiringOnboardings.getByApplicant(jobapplicantId));
    
        return response.data;
  } catch (error) {
    console.error("Error fetching employee details:", error);
    return null;
  }
};
